import React, { useRef,useState } from 'react'
import styles from "./workDetailSec.module.css";
import { workDetailBanner } from '../../../assets';
import { IMAGE_URL } from '../../helpers/api_helper';
import VideoPopup from '../videoPopup/VideoPopup';

const WorkDetailBanner = ({workData}) => {
        const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
        const [currentVideoSrc, setCurrentVideoSrc] = useState('');
           const videoPopupRef = useRef(null);
            const popupVideoRef = useRef(null);
            const videoRef = useRef(null);

            const handlePlayClick = (videoSrc) => {
                setCurrentVideoSrc(videoSrc);
                const currentVideo = videoRef.current;
                if (currentVideo) {
                    //setVideoCurrentTime(currentVideo.currentTime);  // Store the current time of the video when clicked
                }
                setIsVideoPopupOpen(true);
            };
        
            const handleCloseClick = () => {
                setIsVideoPopupOpen(false);
            };

    
    return (
        <>
     
        <div className={styles.WorkDetailBanner}>
        {workData.image ? (
            workData.image.toLowerCase().endsWith('.jpg') || 
            workData.image.toLowerCase().endsWith('.jpeg') || 
            workData.image.toLowerCase().endsWith('.png') || 
            workData.image.toLowerCase().endsWith('.webp') ? (
                <img
                    src={`${IMAGE_URL}/work/${workData.image}`}
                    loading="lazy"
                    alt="Work Detail Banner"
                />
            ) : (
                <video
                    src={`${IMAGE_URL}/work/${workData.image}`}
                    onClick={()=> handlePlayClick(`${IMAGE_URL}/work/${workData.image}`)}
                    autoPlay
                    muted
                    loop
                    playsInline
                    width="100%"
                    height="100%"
                />
            )
        ) : null}
    </div>

    {isVideoPopupOpen && (
            <VideoPopup videoPopupRef = {videoPopupRef} handleCloseClick = {handleCloseClick} popupVideoRef = {popupVideoRef} currentVideoSrc = {currentVideoSrc}></VideoPopup>
                           
                        )}
        </>
    )
}

export default WorkDetailBanner
